module.exports = __webpack_public_path__ + "static/img/green-tick.cb42859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/green-tick.jpg
// module id = LZHg
// module chunks = 0